interface IReminderEmail {
  emailSubject: string
  emailBody: string
}

interface IReminderPost {
  coverTitle: string
  coverLetter: string
}

export interface BasicReminderSetting {
  active: boolean
}

export interface BeforeReminderSetting extends BasicReminderSetting, IReminderEmail {
  nDays: number
}

export type OnDueDateSetting = BasicReminderSetting & IReminderEmail

export enum RepeatInterval {
  once = 'once',
  everyNDays = 'everyNDays',
}

export interface AfterReminderSetting extends BasicReminderSetting, IReminderEmail {
  nDays: number
  repeat: RepeatInterval
}

export interface PostAfterReminderSetting extends BasicReminderSetting, IReminderPost {
  nDays: number
}

export type IReminderSetting =
  | OnDueDateSetting
  | AfterReminderSetting
  | BeforeReminderSetting
  | PostAfterReminderSetting

export enum ReminderType {
  BeforeDueDate,
  OnDueDate,
  AfterDueDate,
  PostAfterDueDate,
}

export interface IReminderSettings {
  companyId?: number
  userId?: number
  activationDate: string
  createNotification: boolean
  beforeDueDate: BeforeReminderSetting
  onDueDate: OnDueDateSetting
  afterDueDate: AfterReminderSetting
  postAfterDueDate: PostAfterReminderSetting
}

export interface IRemindersStore {
  loaded: boolean
  settings: IReminderSettings
}
